


































































































































import { BAvatar, BButton, VBTooltip } from "bootstrap-vue";
import { computed, defineComponent, ref, Ref } from "@vue/composition-api";

import ActiveChatSidebarApps from "./apps.vue";
import ActiveChatSidebarContact from "./contact.vue";
import ActiveChatSidebarInternalComments from "./internalComments.vue";
import ActiveChatSidebarTags from "./tags.vue";
//@ts-ignore
import useVerticalLayout from "@core/layouts/layout-vertical/useVerticalLayout";
import useUserSettings from "@/composables/useUserSettings";
import { useApps } from "@/composables/useApps";

export default defineComponent({
    components: {
        BButton,
        BAvatar,
        ActiveChatSidebarContact,
        ActiveChatSidebarTags,
        ActiveChatSidebarInternalComments,
        ActiveChatSidebarApps,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        mobilePluginBarActive: {
            type: Boolean,
            default: false,
        },
        activeChat: {
            type: Object,
            required: true,
        },
        internalComments: {
            type: Array,
            required: true,
        },
    },

    setup(props, { root }) {
        const expanded = ref(false);
        const collapseBtnIsVisible = ref(false);
        const activeSidebarView = ref();
        const activeAppId: Ref<number | undefined> = ref<number | undefined>();
        const { updateVerticalMenuCollapsed } = useVerticalLayout();
        const { getUserSetting } = useUserSettings();

        const { apps, loadApps } = useApps();
        loadApps();
        const toggleActive = (id: string, appId?: number) => {
            // Remove all tooltips because they can get stuck in the way
            setTimeout(() => {
                root.$emit("bv::hide::tooltip");
            }, 250);

            // If we clicked the same app that is already open, we collapse
            // Sidebar-apps also need to match the4 activeAppId
            if (
                (id === "sidebar-apps" && activeSidebarView.value === id && appId === activeAppId.value) ||
                (activeSidebarView.value === id && id !== "sidebar-apps")
            ) {
                closeSidebarViews();
                return;
            }

            if (id === "sidebar-contact") {
                collapseBtnIsVisible.value = false;
            }

            if (!collapseBtnIsVisible.value && id != "sidebar-contact") {
                setTimeout(() => {
                    collapseBtnIsVisible.value = true;
                }, 500);
            }

            activeSidebarView.value = id;
            activeAppId.value = appId;

            if (expanded.value != true) {
                expanded.value = true;
                updateVerticalMenuCollapsed(true);
            }
        };

        if (Boolean(Number(getUserSetting("rightSideMenuIsOpen"))) !== expanded.value) {
            toggleActive("sidebar-contact");
            updateVerticalMenuCollapsed(true);
        }

        const closeSidebarViews = () => {
            expanded.value = false;
            updateVerticalMenuCollapsed(false);
            // Close the active app AFTER the animation (0.4s) is done
            setTimeout(() => {
                activeSidebarView.value = undefined;
            }, 500);
        };

        // Make to perfect scrollbar scrollable from within apps via app.utils
        const sidebarContentScrollbar = ref();
        const scrollToTop = () => {
            const scrollEl = sidebarContentScrollbar.value.$el || sidebarContentScrollbar.value;
            scrollEl.scrollTop = 0;
        };

        return {
            toggleActive,
            closeSidebarViews,
            expanded,
            collapseBtnIsVisible,
            activeSidebarView,
            internalCommentsLength: computed(() => props.internalComments.length),

            activeApps: computed(() => apps.value.filter((app) => app.package && app.settings?.active === true)),
            activeAppId,

            sidebarContentScrollbar,
            scrollToTop,
        };
    },
});
